<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"></organization-select>        
                                            
<site-select            #siteManager
                        [org]           =   "orgManager?.currentValue"
                        autoSelectFirst =   "true"
                        class           =   "mr-3"
                        (change)        =   "setSite($event)"></site-select>
<br>

<help-alert 
            text        = "help.page.message.field"
            action      = "help.page.message.action" 
            info        = "help.info"
            description = "help.page.message.description">
</help-alert>

<br>
<br>

<custom-table           #messageTable
                        table_id            =   "messageTable"
                        no_title_value      =   "tables.messages.no_title_value"
                        title_single        =   "tables.messages.title_single"
                        title_multiple      =   "tables.messages.title"
                        filter_title        =   "tables.messages.filter_title"
                        search_title        =   "tables.messages.search_title"
                        [columns]           =   "messageColumns"
                        [values]            =   "values"
                        [parent]            =   "this"
                        [create]            =   "true"
                        [update]            =   "true"
                        [delete]            =   "true"></custom-table>